<nav class="navbar sticky-top cc-nav-custom">
    <div class="row w-100 my-1">
        <div class="col-12 d-flex align-items-center justify-content-between">
            <div class="d-flex align-items-center justify-content-start">
                <img src="assets/img/logo-sofofa-color.svg" alt="logo-sofofa" width="83px" height="33px">
                <p class="cc-titulo-header m-0 ms-4">Centralización de Remuneraciones</p>
            </div>
            <div class="d-flex align-items-center justify-content-end">
                <!-- <button type="button" class="cc-btn-notificaciones" (click)="toggleNotificaciones()">
                    <img src="assets/img/icon-notificaciones.svg" alt="">
                    <span class="cc-badge-notificaciones rounded-pill" *ngIf="nroNotificacionesNoLeidas > 0">
                        {{ (nroNotificacionesNoLeidas > 100) ? '99+' : nroNotificacionesNoLeidas }}
                    </span>
                </button> -->
                <!-- esto estaba antes  -->
                <!-- <span class="badge ms-3 me-1">
                    <app-avatar [name]="user?.attributes?.name[0] || user?.usNames"
                        [imgUrl]="user?.attributes?.profile_pic[0] || null" [size]="36" [useRandomColor]="true">
                    </app-avatar>
                </span> -->
                <span class="badge ms-3 me-1">
                    <app-avatar [name]="inicialesUsuario" [imgUrl]="null" [size]="36" [useRandomColor]="false">
                    </app-avatar>
                </span>
                <div class="d-flex align-items-center gap-2">
                    <div class="d-flex flex-column">
                        <p class="mb-0 cc-nombre-usuario">
                            {{ user?.attributes?.name[0] || user?.usNames }}
                        </p>
                        <ng-container *ngIf="user?.organizations">
                            <p class="mb-0 cc-cargo-usuario">{{ user?.organizations[0]?.title | titlecase }}</p>
                        </ng-container>
                        <!-- <ng-container *ngIf="profileNames">
                            <p class="mb-0 cc-cargo-usuario" [matTooltip]="profileNames.length > 25 ? profileNames : ''"> 
                                {{ profileNames | truncate: 25 }} 
                            </p>
                        </ng-container> -->
                        <ng-container *ngIf="gerProfilePrincipal">
                            <p class="mb-0 cc-cargo-usuario"
                                [matTooltip]="gerProfilePrincipal.length > 25 ? gerProfilePrincipal : ''">
                                {{ gerProfilePrincipal | truncate: 25 }}
                            </p>
                        </ng-container>
                    </div>
                    <div ngbDropdown placement="bottom-end">
                        <button type="button" class="btn p-0 border-0 bg-transparent logout-menu-toggle"
                            ngbDropdownToggle>
                            <i class="pi pi-ellipsis-v fs-5"></i>
                        </button>

                        <div ngbDropdownMenu class="profile-options-menu-dropdown">
                            <button ngbDropdownItem type="button" class="logout-menu-item" (click)="logout()">
                                <i class="pi pi-sign-out me-2"></i>
                                Cerrar sesión
                            </button>
                        </div>
                    </div>

                    <!-- <div ngbDropdown placement="bottom-end" class="profile-options-menu" *ngIf="profiles?.length">
                        <button ngbDropdownToggle type="button" class="btn profile-options-menu-trigger"
                            aria-label="Seleccionar perfil">
                            <img src="assets/icons/options-three-dots.svg" alt="Opciones"
                                class="profile-options-menu-icon" />
                        </button>

                        <div ngbDropdownMenu class="profile-options-menu-dropdown">
                            <button *ngFor="let profile of profiles" type="button" ngbDropdownItem
                                class="profile-options-menu-item"
                                [class.active-profile]="profile.prId === profilePrincipal"
                                (click)="selectProfile(profile.prId)">
                                {{ profile.prName }}
                            </button>
                        </div>
                    </div> -->
                </div>
            </div>
        </div>
    </div>
</nav>